/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Grid = void 0;

var react_1 = __importDefault(require("react"));

var name = 'Grid';
exports.name = name;

var Grid = function Grid(_ref) {
  var Frame = _ref.Frame,
      styles = _ref.styles,
      theme = _ref.theme;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        size: 'lg'
      };
      _this.getGridWidth = _this.getGridWidth.bind(_assertThisInitialized(_this));
      _this.onWindowResize = _this.onWindowResize.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (window) {
          window.addEventListener('resize', this.onWindowResize);
        }

        this.onWindowResize();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (window) {
          window.removeEventListener('resize', this.onWindowResize);
        }
      }
    }, {
      key: "getGridWidth",
      value: function getGridWidth() {
        var _this$props = this.props,
            lg = _this$props.lg,
            md = _this$props.md,
            sm = _this$props.sm;
        var size = this.state.size;
        var numberOfItems = this.props[size] || sm || md || lg || 1;
        return {
          maxWidth: "".concat(100 / numberOfItems, "%")
        };
      }
    }, {
      key: "onWindowResize",
      value: function onWindowResize() {
        var _a, _b;

        if (window) {
          var size = this.state.size;
          var mobileBreakPoint = ((_a = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _a === void 0 ? void 0 : _a.mobile) || 991;
          var tabletBreakPoint = ((_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.tablet) || 1200;
          var width = window.innerWidth;

          if (width <= mobileBreakPoint && size !== 'sm') {
            this.setState({
              size: 'sm'
            });
          } else if (width <= tabletBreakPoint && width > mobileBreakPoint && size !== 'md') {
            this.setState({
              size: 'md'
            });
          } else if (width > mobileBreakPoint && width > tabletBreakPoint && size !== 'lg') {
            this.setState({
              size: 'lg'
            });
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            after = _this$props2.after,
            before = _this$props2.before,
            classes = _this$props2.classes,
            _this$props2$items = _this$props2.items,
            items = _this$props2$items === void 0 ? [] : _this$props2$items,
            renderItem = _this$props2.renderItem;
        return react_1.default.createElement(Frame, {
          className: ['Grid__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, items.map(function (item) {
          return react_1.default.createElement(Frame, {
            className: ['Grid__item', classes === null || classes === void 0 ? void 0 : classes.item],
            key: item.name,
            style: Object.assign(Object.assign({}, _this2.getGridWidth()), styles === null || styles === void 0 ? void 0 : styles.item)
          }, renderItem(item));
        }), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Grid = Grid;

var style = function style(theme) {
  var _a;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%'
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Grid) === null || _a === void 0 ? void 0 : _a.container),
    item: {
      display: 'flex'
    }
  };
};

exports.style = style;